import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["eventSelect", "trackSelect", "daySelect"];
  static values = {
    tracks: Object,
    days: Object
  };

  connect() {
    this.tracksMap = new Map(Object.entries(this.tracksValue || {}));
    this.daysMap = new Map(Object.entries(this.daysValue || {}));

    setTimeout(() => {
      this.storeOriginalOptions();

      const selectedEventId = this.eventSelectTarget.value;
      if (selectedEventId) {
        this.filterByEventId(selectedEventId);
      }
    }, 100);
  }

  storeOriginalOptions() {
    if (this.hasTrackSelectTarget) {
      const trackSelect = this.trackSelectTarget;
      const choicesInstance = trackSelect.choicesInstance;

      if (choicesInstance) {
        const choices = choicesInstance._currentState.choices;
        this.trackOptions = choices.map(choice => ({
          value: choice.value,
          label: choice.label,
          eventId: this.tracksMap.get(choice.value.toString())
        }));
      }
    }

    if (this.hasDaySelectTarget) {
      const daySelect = this.daySelectTarget;
      const choicesInstance = daySelect.choicesInstance;

      if (choicesInstance) {
        const choices = choicesInstance._currentState.choices;
        this.dayOptions = choices.map(choice => ({
          value: choice.value,
          label: choice.label,
          eventId: this.daysMap.get(choice.value.toString())
        }));
      }
    }
  }

  filterByEvent(event) {
    const selectedEventId = event.target.value;
    this.filterByEventId(selectedEventId);
  }

  filterByEventId(selectedEventId) {
    if (!selectedEventId) {
      this.resetFilters();
      return;
    }

    if (this.hasTrackSelectTarget && this.trackOptions) {
      this.filterSelect(this.trackSelectTarget, this.trackOptions, selectedEventId);
    }

    if (this.hasDaySelectTarget && this.dayOptions) {
      this.filterSelect(this.daySelectTarget, this.dayOptions, selectedEventId);
    }
  }

  filterSelect(selectElement, allOptions, eventId) {
    const choicesInstance = selectElement.choicesInstance;

    if (!choicesInstance) {
      return;
    }

    const currentValue = selectElement.value;

    const filteredOptions = allOptions.filter(opt => {
      if (!opt.value) {
        return true;
      }
      return opt.eventId && opt.eventId.toString() === eventId.toString();
    });

    choicesInstance.clearStore();
    choicesInstance.setChoices(
      filteredOptions.map(opt => ({
        value: opt.value,
        label: opt.label,
        selected: opt.value === currentValue,
        disabled: false
      })),
      'value',
      'label',
      true
    );
  }

  resetFilters() {
    if (this.hasTrackSelectTarget && this.trackOptions) {
      const choicesInstance = this.trackSelectTarget.choicesInstance;
      if (choicesInstance) {
        choicesInstance.clearStore();
        choicesInstance.setChoices(
          this.trackOptions.map(opt => ({
            value: opt.value,
            label: opt.label,
            selected: false,
            disabled: false
          })),
          'value',
          'label',
          true
        );
      }
    }

    if (this.hasDaySelectTarget && this.dayOptions) {
      const choicesInstance = this.daySelectTarget.choicesInstance;
      if (choicesInstance) {
        choicesInstance.clearStore();
        choicesInstance.setChoices(
          this.dayOptions.map(opt => ({
            value: opt.value,
            label: opt.label,
            selected: false,
            disabled: false
          })),
          'value',
          'label',
          true
        );
      }
    }
  }
}
